import React from 'react';
import { object, string, ref } from 'yup';
import omit from 'lodash/omit';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

const defaults = {
  active: true,
  email: '',
  password: '',
  confirmPassword: '',
  roles: ['admin'],
};

const FormAdmin = ({
  admin,
}) => (
  <FormResource
    {...{
      defaults,
      schema: object({
        email: string().email().required(),
        ...(!admin ? {
          password: string().required(),
        } : {}),
        confirmPassword: string()
          .when(
            'password',
            {
              is: (p) => p,
              then: (s) => s.required().oneOf(
                [ref('password')],
                'Password does not match',
              ),
            },
          ),
      }),
      stored: admin,
      api: '/api/core/users/admins',
      onSubmit: (v) => omit(v, !v.password ? 'password' : null),
    }}
  >
    <div className="form-group">
      <label>Active</label>
      <FormCheckGroup
        name="active"
        type="checkbox"
        label=""
        asSwitch
      />
    </div>
    <FormGroup name="email" />
    <div className="form-row">
      <div className="col">
        <FormGroup
          name="password"
          type="password"
          placeholder="Leave this blank to keep the stored password"
        />
      </div>
      <div className="col">
        <FormGroup
          name="confirmPassword"
          type="password"
          placeholder="Leave this blank to keep the stored password"
        />
      </div>
    </div>
  </FormResource>
);

export default FormAdmin;
